export default function Hidden() {
  return <div>This is hidden</div>;
}
